import store from '@/store/index'
import account_pb from "@/common/api/services/account/account_pb";
import GrpcService from './GrpcService'; '@/common/GrpcService'


export function convertProtoToJSON(protoMessage) {
  const jsonObject = {};

  const fields = protoMessage.toObject();
  for (const key in fields) {
    if (fields.hasOwnProperty(key)) {
      const value = fields[key];

      // Check if the value is another nested message
      if (value && typeof value.toObject === 'function') {
        jsonObject[key] = convertProtoToJSON(value);
      } else {
        jsonObject[key] = value
      }
    }
  }

  return jsonObject;
}

export async function refreshToken(metadata) {
  try {
    const request = new account_pb.RefreshTokenRequest()
    request.setRefreshToken(store.state.refresh_token)
    const response = await GrpcService.sendRequest('account', 'refreshToken', request, metadata)
    store.commit('setAccessToken', response.token.accessToken)
    store.commit('setRefreshToken', response.token.refreshToken)
  } catch (err) {
    this.$toast.add({ severity: 'error', summary: err.summary, detail: err.detail, life: 6000 })
  }
}

export function getBaseUrl(service) {
  let separator = process.env.VUE_APP_SUBDOMAIN_SEPARATOR
  const baseUrl = process.env.VUE_APP_BASE_URL
  const isProduction = process.env.VUE_APP_ENV != "development"
  const isPathMode = separator === '/'

  if (isPathMode) {
    switch (service) {
      case 'account':
        return isProduction ? `https://${baseUrl}/account/svc` : `${process.env.VUE_APP_ACCOUNT_SERVER}`
      case 'gateway':
        return isProduction ? `https://${baseUrl}/gateway` : `${process.env.VUE_APP_GATEWAY_SERVER}`
      case 'chat':
        return isProduction ? `https://${baseUrl}/chat` : `${process.env.VUE_APP_CHAT_SERVER}`
      case 's3':
        return isProduction ? `https://${baseUrl}/s3` : `${process.env.VUE_APP_CHAT_SERVER}`
      case 'voip':
        return isProduction ? `https://${baseUrl}/voip/svc` : `${process.env.VUE_APP_VOIP_SERVER}`
      case 'ai':
        return isProduction ? `https://${baseUrl}/ai/svc` : `${process.env.VUE_APP_AI_SERVER}`
      case 'post':
        return isProduction ? `https://${baseUrl}/post/svc` : `${process.env.VUE_APP_POST_SERVER}`
      default:
        throw new Error(`Unsupported service type: ${service}`);
    }
  }

  const concatSeparator = process.env.VUE_APP_SUBDOMAIN_VERSION === '.v3' ? '.' : separator

  switch (service) {
    case 'account':
      return isProduction ? `https://account${separator}svc${concatSeparator}${baseUrl}` : `${process.env.VUE_APP_ACCOUNT_SERVER}`
    case 'gateway':
      return isProduction ? `https://gateway${concatSeparator}${baseUrl}` : `${process.env.VUE_APP_GATEWAY_SERVER}`
    case 'chat':
      return isProduction ? `https://chat${concatSeparator}${baseUrl}` : `${process.env.VUE_APP_CHAT_SERVER}`
    case 's3':
      return isProduction ? `https://s3${concatSeparator}${baseUrl}` : `${process.env.VUE_APP_CHAT_SERVER}`
    case 'voip':
      return isProduction ? `https://voip${separator}svc${concatSeparator}${baseUrl}` : `${process.env.VUE_APP_VOIP_SERVER}`
    case 'ai':
      return isProduction ? `https://ai${separator}svc${concatSeparator}${baseUrl}` : `${process.env.VUE_APP_AI_SERVER}`
    case 'post':
      return isProduction ? `https://post${separator}svc${concatSeparator}${baseUrl}` : `${process.env.VUE_APP_POST_SERVER}`
    default:
      throw new Error(`Unsupported service type: ${service}`);
  }
}

export function getNetworkIdByUsername(username) {
  const data = store.state.all_networks
  const organization = data.find((item) => item.organization.username === username);
  return organization ? organization.organization.id : null;
}

export function getUsernameByNetworkId(networkId) {
  const data = store.state.all_networks
  const organization = data.find((item) => item.organization.id === networkId);
  return organization ? organization.organization.username : networkId;
}